module.exports = __webpack_public_path__ + "img/ingredienten-bloemkoolcouscous-met-abrikozen-en-kip.573541ef.jpg";